/**
 * Kurzes „Gute Wahl!"-Feedback im In-den-Warenkorb-Button nach erfolgreichem ATC
 */
(function () {
  const FEEDBACK_TEXT = 'Gute Wahl! 👍🏼';
  const FEEDBACK_MS = 2200;
  let lastAtcButton = null;

  function showAtcFeedback(button) {
    if (!button || button.disabled) return;

    const span = button.querySelector('span');
    if (!span || span.classList.contains('sold-out-message')) return;

    if (!button.dataset.rkAtcOriginal) {
      button.dataset.rkAtcOriginal = span.textContent.trim();
    }

    span.textContent = FEEDBACK_TEXT;
    button.classList.add('rk-atc-success');

    clearTimeout(button._rkAtcTimeout);
    button._rkAtcTimeout = setTimeout(() => {
      span.textContent = button.dataset.rkAtcOriginal;
      button.classList.remove('rk-atc-success');
    }, FEEDBACK_MS);
  }

  function init() {
    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest('.product-form__submit');
        if (button) lastAtcButton = button;
      },
      true
    );

    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source !== 'product-form' || !lastAtcButton) return;
        showAtcFeedback(lastAtcButton);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
